import { render } from "./MoMo.vue?vue&type=template&id=cd0c7a8c&scoped=true"
import script from "./MoMo.vue?vue&type=script&lang=js"
export * from "./MoMo.vue?vue&type=script&lang=js"

import "./MoMo.vue?vue&type=style&index=0&id=cd0c7a8c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd0c7a8c"]])

export default __exports__